import * as actions from 'actions/GamificationActions/bidAndWinActions';
import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
const { bidAndWinActions } = actions;
const defaultState = {
    asyncStatus: INIT,
    timeStamp: 0,
    data: null,
    bidModal: null
};
export default function (state = defaultState, action) {
    switch (action.type) {
        case bidAndWinActions.GET_BID_AND_WIN_REQUEST:
        case bidAndWinActions.ENTER_BID_AND_WIN_REQUEST:
        case bidAndWinActions.CLAIM_BID_POINT_REQUEST:
        case bidAndWinActions.PLACE_BID_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING,
                bidModal: null
            });
        case bidAndWinActions.GET_BID_AND_WIN_SUCCESS:
        case bidAndWinActions.ENTER_BID_AND_WIN_SUCCESS:
            const initData = action.data;
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                timeStamp: new Date().getTime(),
                data: initData
            });
        case bidAndWinActions.CLAIM_BID_POINT_SUCCESS:
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                data: Object.assign({}, state.data, {
                    userGameInfo: action.data,
                    winnerInfo: null
                })
            });
        case bidAndWinActions.PLACE_BID_SUCCESS:
            const placeBidData = action.data;
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                bidModal: placeBidData,
                data: Object.assign({}, state.data, {
                    userGameInfo: placeBidData.userGameInfo,
                    winnerInfo: null
                })
            });
        case bidAndWinActions.GET_BID_AND_WIN_ERROR:
        case bidAndWinActions.ENTER_BID_AND_WIN_ERROR:
        case bidAndWinActions.CLAIM_BID_POINT_ERROR:
        case bidAndWinActions.PLACE_BID_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR,
                error: action.error
            });
        default:
            return state;
    }
}
